import { Volume2 } from 'lucide-react';
import { useState } from 'react';
import '../ui/CompletingWord.css'; // Reutiliza CSS do tooltip
import WordWithStatus from '../ui/WordWithStatus';

/**
 * Container para um bloco de palavras
 * Gerencia hover e tooltip do bloco completo
 * @param {Object} props
 * @param {Object} props.block - Bloco com metadados (translation, definition) e array de words
 * @param {Function} props.onWordClick - Callback ao clicar em uma palavra
 */
export const BlockWords = ({ block, onWordClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [isShowingTranslation, setIsShowingTranslation] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setShowTooltip(false);
    setIsShowingTranslation(false);
  };

  const handleTranslateClick = (e) => {
    e.stopPropagation();
    setIsShowingTranslation(true);

    // Volta para o conteúdo normal após 2 segundos
    setTimeout(() => {
      setIsShowingTranslation(false);
    }, 2000);
  };

  return (
    <span
      className={`block-container ${isHovered ? 'block-hovered' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {block.words.map((wordObj, index) => (
        <WordWithStatus
          key={`${wordObj.word}-${index}`}
          wordObj={wordObj}
          onWordClick={onWordClick}
        />
      ))}

      {/* Botões de ação do bloco */}
      {isHovered && (
        <div className="word-buttons-container">
          <button
            type="button"
            className="play-audio-btn"
            onClick={(e) => {
              e.stopPropagation();
              // Tocar áudio do bloco completo
              const utterance = new SpeechSynthesisUtterance(block.block);
              utterance.lang = 'en-US';
              utterance.rate = 0.8;
              speechSynthesis.speak(utterance);
            }}
            title={`Pronunciar "${block.block}"`}
            aria-label={`Reproduzir áudio do bloco "${block.block}"`}
          >
            <Volume2
              size={14}
              color="white"
              strokeWidth={2.5}
            />
          </button>

          <button
            type="button"
            className="translate-btn"
            onClick={handleTranslateClick}
            title={`Traduzir "${block.block}"`}
            aria-label={`Traduzir bloco "${block.block}"`}
          >
            <img
              src="/images/flags/br.svg"
              alt="Brasil"
              style={{
                width: "20px",
                height: "20px",
                objectFit: "cover",
                borderRadius: "50%"
              }}
            />
          </button>
        </div>
      )}

      {/* Tooltip com definição ou tradução DO BLOCO */}
      {showTooltip && (
        <div className="word-tooltip">
          {isShowingTranslation ? (
            <div className="tooltip-content">
              <p className="translation">🇧🇷 {block.translation}</p>
            </div>
          ) : (
            <div className="tooltip-content">
              <p className="synonyms">{block.definition}</p>
            </div>
          )}
        </div>
      )}
    </span>
  );
};

